import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { ShopItemType } from '../../../../../types/shop';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import { Props } from './ShopAll';

type StateProps = Pick<Props, 'isEmpty' | 'isOwner'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const hasNoCommissionItems = !streamSelectors.getItems(
    state,
    getShopItemsStreamId(ShopItemType.COMMISSIONS)
  ).length;
  const hasNoPrints = !streamSelectors.getItems(
    state,
    getShopItemsStreamId(ShopItemType.PRINTS)
  ).length;
  const hasNoPremiumContentItems = !streamSelectors.getItems(
    state,
    getShopItemsStreamId(ShopItemType.PREMIUM_CONTENT)
  ).length;
  const hasNoPremiumFoldersItems = !streamSelectors.getItems(
    state,
    getShopItemsStreamId(ShopItemType.PREMIUM_FOLDERS)
  ).length;
  const hasNoAdoptableItems = !streamSelectors.getItems(
    state,
    getShopItemsStreamId(ShopItemType.ADOPTABLES)
  ).length;

  const adoptsEmpty = flagEnabled(state, 'adoptables')
    ? hasNoAdoptableItems
    : true;

  return {
    isEmpty:
      hasNoCommissionItems &&
      hasNoPrints &&
      hasNoPremiumContentItems &&
      hasNoPremiumFoldersItems &&
      adoptsEmpty,
    isOwner: isCurrentUserProfileOwner(state),
  };
};

export default connect(mapStateToProps);
